export enum InternalAccessTab {
  Users = 'users',
  Roles = 'roles',
}
